module.exports = {
  IosToggle: require('./dist/components/toggle/ios'),
  SkewToggle: require('./dist/components/toggle/skewed'),
  FlipToggle: require('./dist/components/toggle/flip')
}



//////////////////
// WEBPACK FOOTER
// ./~/reacttoggles/index.js
// module id = 22
// module chunks = 0